/* eslint-disable sort-keys */
export default {
  light: {
    // Booking Widgets
    "booking-widget-heading-bg-color": "primary-500",
    "booking-widget-heading-fg-color": "neutral-900",
    "booking-widget-heading-icon-color": "neutral-900",
    "primary-header-background": "neutral-900",
  },
  dark: {},
};
